import { render, staticRenderFns } from "./DrugTable.vue?vue&type=template&id=76259d9b&scoped=true"
import script from "./DrugTable.vue?vue&type=script&lang=js"
export * from "./DrugTable.vue?vue&type=script&lang=js"
import style0 from "./DrugTable.vue?vue&type=style&index=0&id=76259d9b&prod&scoped=true&lang=css"
import style1 from "./DrugTable.vue?vue&type=style&index=1&id=76259d9b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76259d9b",
  null
  
)

export default component.exports